export const validateBannerOnChange = (name, value, preserveError) => {
   let errors = { ...preserveError };
   switch (name) {
      case "name":
         if (!value) {
            errors.name = "Please enter banner name";
         } else {
            delete errors.name
         }
         break;
      case "banner_image":
         if (!value) {
            errors.banner_image = "Please select banner image";
         } else {
            delete errors.banner_image
         }
         break;
      case "description":
         if (!value) {
            errors.description = "Please enter description";
         } else {
            delete errors.description
         }
         break;
      case "sort_order_by":
         if (!value || value <= 0) {
            errors.sort_order_by = "Please enter banner order number";
         } else {
            delete errors.sort_order_by
         }
         break;
      default:
         break;
   }

   return errors;
};

export const validateBanner = (bannerData = {}) => {
   const {
      name,
      banner_image,
      description,
      sort_order_by
   } = bannerData

   const errors = {}

   if (!name) {
      errors.name = "Please enter banner name";
   }
   if (!banner_image || (!banner_image.url && !banner_image.base64url)) {
      errors.banner_image = "Please select banner image";
   }
   if (!description) {
      errors.description = "Please enter description";
   }
   if (!sort_order_by || sort_order_by <= 0) {
      errors.sort_order_by = "Please enter banner order number";
   }

   return errors
}
